module.exports = __webpack_public_path__ + "img/icon-watch.5c5659cb.svg";